import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SuccessFalureComponent } from './success-falure.component';

const routes: Routes = [{ path: '', component: SuccessFalureComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuccessFalureRoutingModule { }
